export default "__VITE_ASSET__BICFaYgW__"